/**
 * Global AbortController manager for canceling all pending requests
 * This helps ensure immediate cancellation of all network activity during critical operations like wallet disconnect
 */

// Global abort controller that can be used to cancel all requests
let globalAbortController = new AbortController();

/**
 * Get a signal from the global abort controller
 * @returns AbortSignal that will be aborted when abortAllRequests is called
 */
export function getGlobalAbortSignal(): AbortSignal {
  return globalAbortController.signal;
}

/**
 * Abort all pending requests and create a new controller
 * This should be called when disconnecting the wallet or during other critical operations
 */
export function abortAllRequests(): void {
  console.log('Aborting all pending network requests');
  try {
    globalAbortController.abort();
  } catch (err) {
    console.error('Error aborting requests:', err);
  } finally {
    // Create a new controller for future requests
    globalAbortController = new AbortController();
  }
}

/**
 * Register an event listener for the wallet disconnect event
 * This will automatically abort all requests when the wallet is disconnected
 */
export function setupGlobalAbortListener(): void {
  window.addEventListener('wallet-disconnect', () => {
    console.log('Wallet disconnect detected, aborting all pending requests');
    abortAllRequests();
  });
}

// Set up the listener as soon as this module is imported
setupGlobalAbortListener(); 